export function toNumberOrNull(value: number | null): number | null {
  return value === null ? null : Number(value);
}
